
/* ================================
   Emoji Regex Matcher
================================ */
export function checkEmojiRegex(text = '') {
    const compoundEmojiRegex = /👨‍👩‍👦‍👦|👨‍👩‍👧‍👦|👨‍👩‍👧‍👧|👨‍👩‍👦|👨‍👩‍👧|👩‍👧‍👦|👨‍👧‍👦|👩‍👦|👨‍👦|🤷‍♀️|🤷‍♂️|☕|⭐|✈|☔|(?:[\u{1F300}-\u{1F9FF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA70}-\u{1FAFF}]|\u200D)/gu;
    const matches = text.match(compoundEmojiRegex);
    return matches;
}

// export function checkEmojiRegex(text = '') {
//     const compoundEmojiRegex =
//         /👨‍👩‍👦‍👦|👨‍👩‍👧‍👦|👨‍👩‍👧‍👧|👨‍👩‍👦|👨‍👩‍👧|👩‍👧‍👦|👨‍👧‍👦|👩‍👦|👨‍👦|🤷‍♀️|🤷‍♂️|(?:[\u{1F300}-\u{1F9FF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA70}-\u{1FAFF}]|[\u2600-\u26FF]|\u{2B50}|[\u2700-\u27BF]|\u200D)/gu;

//     return text.match(compoundEmojiRegex);
// }

/* ================================
   Emoji Regex Matcher
================================ */

export function commonemojiRegex() {
    const emojiRegex = /(\p{Extended_Pictographic}(?:\u200D\p{Extended_Pictographic})*|[\u{1F1E6}-\u{1F1FF}]{2})/gu;
    return emojiRegex;
}

/* ================================
   Get Difference Between Two Strings
================================ */

export function getDifference(totalValue = '', prevValue = '') {
    const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
    const totalChars = [...segmenter.segment(totalValue)].map(s => s.segment);
    const prevChars = [...segmenter.segment(prevValue)].map(s => s.segment);

    // Find the first index where they differ
    let start = 0;
    while (start < totalChars.length && start < prevChars.length && totalChars[start] === prevChars[start]) {
        start++;
    }

    // Find the last index where they differ (from the end)
    let endTotal = totalChars.length - 1;
    let endPrev = prevChars.length - 1;
    while (endTotal >= start && endPrev >= start && totalChars[endTotal] === prevChars[endPrev]) {
        endTotal--;
        endPrev--;
    }

    // Extract the changed segment (middle part)
    const changedPart = totalChars.slice(start, endTotal + 1).join('');
    return changedPart;
}


/* ================================
   Emoji Whitelist
================================ */

export const ALLOWED_EMOJIS = [
    '😊', '😄', '😁', '😅', '😆', '😂', '🤣', '😋', '😉', '😎',
    '😍', '😙', '😘', '🥰', '🤨', '😮', '🙄', '😏', '😣', '😥',
    '😪', '😭', '😴', '😵', '🤒', '🤕', '🤮', '🥳', '🤭', '🤷‍♀️',
    '🤷‍♂️', '👣', '💑', '👨‍👩‍👧', '👨‍👩‍👦', '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦',
    '👨‍👩‍👧‍👧', '👭', '👫', '👴', '👵', '👨', '👦', '👶', '🤴',
    '👸', '👍', '👎', '👌', '👏', '👊', '👋', '🙏', '🤝', '🎂',
    '🎉', '🎊', '🎃', '🎄', '🎑', '🎁', '👑', '🥉', '🏆', '🎶',
    '🍕', '🍔', '🍟', '🌭', '🍦', '🍩', '🧁', '🍫', '☕', '🥂',
    '🍻', '🍺', '💐', '🌺', '🥀', '🌱', '🍁', '🌟', '⭐', '🌞',
    '🌜', '☔', '🌄', '✈', '🚅', '🚌', '🚗'
];

/* Convert to Set for O(1) lookup */
const ALLOWED_EMOJI_SET = new Set(ALLOWED_EMOJIS);

/* ================================
   Grapheme-Safe Split
================================ */

export function extractGraphemes(text = '') {
    if (typeof Intl !== 'undefined' && Intl.Segmenter) {
        const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
        return [...segmenter.segment(text)].map(s => s.segment);
    }
    return Array.from(text);
}

/* ================================
   Check if Text Contains Allowed Emoji
================================ */

export function containsAllowedEmoji(text = '') {
    return extractGraphemes(text).some(g => ALLOWED_EMOJI_SET.has(g));
}

/* ================================
   List allowed emojis found
================================ */

export function getAllowedEmojisFromText(text = '') {
    return extractGraphemes(text).filter(g => ALLOWED_EMOJI_SET.has(g));
}